import { faCommentsQuestion } from "@jewlr/pro-regular-svg-icons/faCommentsQuestion"
import { faGem } from "@jewlr/pro-regular-svg-icons/faGem"
import { faGift } from "@jewlr/pro-regular-svg-icons/faGift"
import { faGlobe } from "@jewlr/pro-regular-svg-icons/faGlobe"
import { faQuestionCircle } from "@jewlr/pro-regular-svg-icons/faQuestionCircle"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"

import { TitleWithDivider } from "areas/helpdesk/index"
import Loading from "areas/helpdesk/loading"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import fetchCollectionData from "hoc/helpdesk/fetch-collection-results"
import withHelpdesk from "hoc/helpdesk/with-helpdesk"

const BrowseHelpTopics = ({ results }) => {
  if (!results) {
    return <Loading />
  }
  const collectionIds = Object.keys(results)
  if (!collectionIds.length) {
    return <Loading />
  }
  const categoryIdPairs = [
    // Order Information / Returns
    {
      categoryId: "5ea1ec702c7d3a7e9aeb86e1",
      collectionId: "5e9f516d2c7d3a7e9aeb5bfe",
    },
    // Order Information / Repairs and Resizing
    {
      categoryId: "5ea1ec692c7d3a7e9aeb86e0",
      collectionId: "5e9f516d2c7d3a7e9aeb5bfe",
    },
    // Order Information / Shipping
    {
      categoryId: "5ea1ec7b04286364bc98e7ba",
      collectionId: "5e9f516d2c7d3a7e9aeb5bfe",
    },
    // General Questions / VIP Rewards
    {
      categoryId: "5ea1a14c2c7d3a7e9aeb8024",
      collectionId: "5e9f51622c7d3a7e9aeb5bfc",
    },
  ]

  const availableAssetSlugs = {
    "general-questions": faCommentsQuestion,
    "international-orders": faGlobe,
    "jewelry-education": faGem,
    "order-information": faGift,
  }

  return (
    <>
      <div className="tablet:gap-24 tablet:grid-cols-2 grid grid-cols-1 gap-8 px-24">
        {(collectionIds || [])
          .filter(
            (collectionId) =>
              !!results[collectionId] &&
              Object.keys(availableAssetSlugs).includes(
                results[collectionId].slug
              )
          )
          .map((collectionId) => {
            const collection = results[collectionId]
            const icon = availableAssetSlugs[collection.slug]

            return (
              <Link
                className="tablet:min-h-250 block"
                data-lc="homepage"
                key={`collection-${collectionId}`}
                to={`/helpdesk/${collectionId}`}
              >
                <div className="tablet:px-40 tablet:py-80 bg-grey-10 tablet:flex-col tablet:gap-32 flex h-full flex-row items-center justify-center gap-8 px-16 py-32 text-center">
                  <FontAwesomeIcon
                    className="text-32 tablet:text-48"
                    data-cy={collection.name}
                    icon={icon}
                  />
                  <h2 className="text-16 tablet:text-24">{collection.name}</h2>
                </div>
              </Link>
            )
          })}
      </div>
      <div className="tablet:w-1/2 m-auto w-4/5 py-24">
        <TitleWithDivider>More Options</TitleWithDivider>
      </div>
      <div className="tablet:flex-row tablet:gap-60 flex flex-col gap-40">
        <div className="tablet:order-1 tablet:py-24 bg-grey-10 tablet:mx-24 order-2 flex flex-1 flex-col items-center justify-center px-24 py-40 text-center">
          <h3 className="text-24 mb-24 text-black">We&apos;re Here To Help!</h3>
          <p className="mb-16">
            Please send us an{" "}
            <Button
              asChild
              className="font-medium"
              text
              underline
              variant="secondary"
            >
              <a href={`mailto:${sl.config.customer_service_email}`}>email</a>
            </Button>{" "}
            with a brief summary of your concern. Our agents will be happy to
            assist.
          </p>
          <p className="mb-24">
            We are also available via LiveChat from{" "}
            {sl.config.customer_service_hours
              .map(({ day, time }) => `${day} from ${time}`)
              .join(", and ")}
            .
          </p>
          <Button asChild variant="primary">
            <Link data-lc="homepage" to="/contact_form">
              Contact Us
            </Link>
          </Button>
        </div>
        <div className="tablet:mx-0 tablet:order-2 order-1 mx-24 flex-1 px-8">
          {categoryIdPairs
            .filter(
              (idPair) =>
                results[idPair.collectionId]?.categories?.[idPair.categoryId]
            )
            .map((idPair) => (
              <Button
                className="border-b-grey-20 w-full justify-start border-b last:border-none"
                key={`collection-category-${idPair.categoryId}`}
              >
                <Link
                  data-lc="homepage"
                  to={`/helpdesk/${idPair.collectionId}/${idPair.categoryId}`}
                >
                  <h3 className="text-18 tablet:text-24 py-24 font-normal">
                    <FontAwesomeIcon
                      className="relative mr-16"
                      icon={faQuestionCircle}
                    />
                    {
                      results[idPair.collectionId].categories[idPair.categoryId]
                        .name
                    }
                  </h3>
                </Link>
              </Button>
            ))}
        </div>
      </div>
    </>
  )
}

BrowseHelpTopics.propTypes = {
  results: PropTypes.object,
}

export default fetchCollectionData(withHelpdesk(BrowseHelpTopics))
